import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PmButtonComponent } from '@libs/ui';

@Component({
  selector: 'pm-not-found',
  templateUrl: './not-found-page.component.html',
  imports: [TranslateModule, PmButtonComponent],
})
export class NotFoundPageComponent {
  private readonly location = inject(Location);

  goBack() {
    this.location.back();
  }
}
